import { render, staticRenderFns } from "./RentalList.vue?vue&type=template&id=4551b009&"
import script from "./RentalList.vue?vue&type=script&lang=js&"
export * from "./RentalList.vue?vue&type=script&lang=js&"
import style0 from "./RentalList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports